export default "__VITE_ASSET__BgS6XWHW__"